<template>
  <div class="information-content">
    <div class="information-title">
      <div class="level-title">{{ info.name || info.code }}</div>
      <i class="el-icon-error icon-error" @click="clearInfo"></i>
    </div>
    <div class="information-type">
      <div
        class="search-button search-button-bgc1"
        v-if="info.supplyPeriod == 1"
      >
        <img class="imgStyle" src="@/assets/images/ldkg-activate.png" alt="" />
        <span style="padding-left: 5px">立等可供</span>
      </div>
      <div
        class="search-button search-button-bgc2"
        v-if="info.supplyPeriod == 4"
      >
        <img class="imgStyle" src="@/assets/images/ghkg-activate.png" alt="" />
        <span style="padding-left: 5px">规划可用</span>
      </div>
      <div
        class="search-button search-button-bgc3"
        v-if="info.supplyPeriod == 3"
      >
        <img class="imgStyle" src="@/assets/images/jhkg-activate.png" alt="" />
        <span style="padding-left: 5px">计划可供</span>
      </div>
      <div class="type-left type-left2" v-show="info.infrastructureName">
        {{ info.infrastructureName }}
      </div>
      <div class="type-left type-left3" v-if="info.isReserve == 1">
        储备土地
      </div>
      <div
        class="panorama"
        @click="handlePanorama(info)"
        v-if="
          info.panoramaVOS &&
          info.panoramaVOS.length &&
          info.panoramaVOS[0].panoramaUrl
        "
      >
        <div class="panorama-title">720全景</div>
        <img src="@/assets/newImg/720-bg.png" />
      </div>
    </div>

    <div class="information-main">
      {{ info.location }}
    </div>
    <div class="information-card">
      <div class="information-card-item">
        <span class="information-name">行政区划：</span>
        <span class="information-num">{{ info.countyName }}</span>
      </div>
      <div class="information-card-item">
        <span class="information-name">用地面积：</span>
        <span class="information-num">{{ info.area }}亩</span>
      </div>
      <div class="information-card-item">
        <span class="information-name"
          >{{ info.supplyPeriod != 4 ? "土地用途" : "用地分类" }}：</span
        >
        <span class="information-num">{{ info.typeName }}</span>
      </div>
<!--      <div class="information-card-item" v-if="info.supplyPeriod == 4">-->
<!--        <span class="information-name">是否已批：</span>-->
<!--        <span class="information-num">{{ info.isApproval ? "是" : "否" }}</span>-->
<!--      </div>-->
      <div class="information-card-item" v-if="info.supplyPeriod != 4">
        <span class="information-name">出让年限：</span>
        <span class="information-num">{{ info.transferDate }}</span>
      </div>
      <div style="display: flex; width: 89%">
        <div class="information-card-item1" v-if="info.supplyPeriod != 4">
          <span class="information-name">行业：</span>
          <span class="information-num" v-if="info.industryTypeName">
            {{ info.industryTypeName }}
          </span>
          <span v-else class="information-num">--</span>
        </div>
        <div class="information-card-item" v-if="info.parkName">
          <span class="information-name">园区：</span>
          <span class="information-num" style="width: 100px">{{
            info.parkName
          }}</span>
        </div>
      </div>
    </div>
    <div class="information-but" v-show="info.supplyPeriod != 4">
      <el-button size="mini" type="primary" @click="goUrl">查看详情</el-button>
      <!-- <el-button size="mini" type="primary" @click="historical"
        >历史变迁</el-button
      > -->
    </div>
  </div>
</template>

<script>
import { getParkRange } from "@/api/setting/investment";
import { createChartDom, removeChartDom } from "@/pulgin/createPulgin";
export default {
  name: "information",
  props: {
    info: {
      type: Object,
    },
    routerData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      data: [
        { name: "宗地编号", value: "无" },
        { name: "土地用途", value: "住宅用地" },
        { name: "用地面积", value: "46.97亩" },
        { name: "出让年限", value: "70年" },
        { name: "土地来源", value: "储备用地" },
        { name: "行政区划", value: "曲靖市" },
      ],
      parkName: "",
    };
  },
  watch: {
    info: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (val.id) {
          getParkRange(val.id).then((res) => {
            if (res.data.success) {
              this.parkName = res.data.data;
            }
          });
        }
      },
    },
  },
  mounted() {},
  methods: {
    clearInfo() {
      removeChartDom();
    },
    goUrl() {
      window.sessionStorage.setItem(
        "breadcrumbNavDataStore",
        '[{"name":"云上选地","path":"/needLand/indexCopy","query":{}}]'
      );
      // this.routerData.push({
      //   path: "/land/detail",
      //   query: { id: this.info.id },
      // });

      const { href } = this.routerData.resolve({
        path: "/land/detail",
        query: {
          id: this.info.id,
          bool: true,
        },
      });
      window.open(href, "_blank");
    },
    historical() {
      this.$eventBus.emit("historicalChanges", true);
    },
    handlePanorama(data) {
      let url = data.panoramaVOS[0].panoramaUrl;
      window.open(url);
      //  console.log(data.handlePanorama);
    },
  },
};
</script>

<style scoped>
.information-content {
  background: #ffffff;
  padding: 10px;
  border-radius: 4px;
  border: 2px solid #d9d9d9;
  width: 350px;
}
.information-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.level-title {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.level-title::before {
  content: "";
  display: block;
  width: 4px;
  height: 16px;
  margin-right: 10px;
  background: #046eff;
}
.icon-error {
  font-size: 20px;
  color: #046eff;
  cursor: pointer;
}
.information-type {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.search-button {
  height: 28px;

  line-height: 28px;
  padding: 0 14px;
  border-radius: 4px;
  font-weight: normal;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
}
.imgStyle {
  width: 12px;
}
.search-button-bgc1 {
  background: #02d64a;
}
.search-button-bgc2 {
  background: #fdba32;
}
.search-button-bgc3 {
  background: #497aff;
}
.type-left {
  background: red;
  padding: 5px 10px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 10px;
}
.type-left1 {
  background: #009ee7;
}
.type-left2 {
  background: #01ba61;
  margin-left: 10px;
}
.type-left3 {
  background: #2090ff;
  margin-left: 10px;
}
.information-main {
  background: #f8f8f8;
  line-height: 25px;
  font-size: 14px;
  color: #8a8a8a;
  padding: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.information-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.information-card-item {
  width: 50%;
  margin-top: 6px;
  display: flex;
  align-items: center;
}
.information-card-item1 {
  width: 100%;
  margin-top: 6px;
  display: flex;
  align-items: center;
}
.information-name {
  font-size: 14px;
  color: #626262;
  /*width: 120px;*/
}
.information-num {
  margin-left: 10px;
  font-size: 14px;
  color: black;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.information-but {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.panorama {
  width: 100px;
  height: 40px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  margin-left: auto;
  /* background: #000; */
  /* align-items: center; */
}
.panorama-title {
  margin-right: 5px;
  padding-top: 5px;
}
.panorama img {
  width: 25px;
  padding-top: 1px;
  height: 25px;
}
</style>